import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../../store/api/rx-factory'
import * as Enpoints from '../../../../../store/api/endpoints'
import moment from 'moment'

export const actions = {
	[Const.RUN_GET_TICKET_DOC]({ commit, state, getters, dispatch }, credentials) {
	    _executeApi('',credentials, credentials.localParams.parameter, {'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result) => {
	      	if(!error){

	          	let url = btoa(result.res_data.body.data.reduce((data, byte) => data + String.fromCharCode(byte), ''));
  				credentials.localParams.parameter.blobToImage(result.res_data.doctype, url)
	        } else {
	        	_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
	        }
	      }
	    );
	  },
	[Const.RUN_CARD_INDIVIDUAL_USERS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CARD_INDIVIDUAL_USERS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CARD_USERS, result.res_data)
			}else{
				commit(Const.SET_CARD_USERS, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_CARD_USERS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_RUN_CARD_USERS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let json = {records: result.res_data.own_card_users, totalRecords: result.res_data.own_card_users_count}
				commit(Const.SET_CARD_USERS, json)
			}else{
				commit(Const.SET_CARD_USERS, {records: [], totalRecords: 0})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  // 	[Const.RUN_CARD_SUB_USERS]({commit, state,getters,dispatch}, credentials){	
		// _executeApi(Enpoints.EP_RUN_CARD_SUB_USERS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
		// 	if(!error){
		// 		let  json = {records: [], totalRecords : 0};
		// 		if(Object.keys(result.res_data).length > 0 && result.res_data.own_card_users && result.res_data.team_card_users){
		// 			json.totalRecords = parseInt(result.res_data.own_card_users.length)+parseInt(result.res_data.team_card_users.length)
		// 			json.records  = result.res_data.own_card_users.concat(result.res_data.team_card_users);
		// 		}
		// 		commit(Const.SET_CARD_SUB_USERS, json)
		// 	}else{
		// 		commit(Const.SET_CARD_SUB_USERS, json)
		// 		_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
		// 	}
		// }) 
  // 	},

  	[Const.RUN_GET_ALL_CREDIT_CARD_BY_USER_ID]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_RUN_GET_ALL_CREDIT_CARD_BY_USER_ID, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.getAllcreditCards = result.res_data
			}else{
				credentials.localParams.parameter.getAllcreditCards = {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  // 	[Const.RUN_GET_ONE_CREDIT_CARD_DETAIL_BY_CARD_ID]({commit, state,getters,dispatch}, credentials){	
		// _executeApi(Enpoints.EP_RUN_GET_ONE_CREDIT_CARD_DETAIL_BY_CARD_ID, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
		// 	if(!error){
		// 		credentials.localParams.parameter.getOnecreditCardDetail = result.res_data
		// 	}else{
		// 		credentials.localParams.parameter.getOnecreditCardDetail = {}
		// 		_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
		// 	}
		// }) 
  // 	},

  // 	[Const.RUN_GET_ALL_WALLETS_BY_USER_ID]({commit, state,getters,dispatch}, credentials){	
		// _executeApi(Enpoints.EP_RUN_GET_ALL_WALLETS_BY_USER_ID, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
		// 	if(!error){
		// 		credentials.localParams.parameter.getAllWallets = result.res_data
		// 	}else{
		// 		credentials.localParams.parameter.getAllWallets = {}
		// 		_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
		// 	}
		// }) 
  // 	},

  	[Const.RUN_GET_ONE_WALLER_DETAIL_BY_CARD_ID]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_RUN_GET_ONE_WALLER_DETAIL_BY_CARD_ID, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.getAllWallets1 = result.res_data
			}else{
				credentials.localParams.parameter.getAllWallets1 = {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_USER_DETAIL_BY_ID]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_RUN_USER_DETAIL_BY_ID, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.userDetail = result.res_data
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_CARD_TRANSACTION_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_RUN_CARD_TRANSACTION_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.transactionList = result.res_data
			}else{
				credentials.localParams.parameter.transactionList = {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},










	[Const.RUN_DOWNLOAD_WITHDRAWAL_DATA]({ commit, state, getters, dispatch },credentials) {
		_executeApi(Enpoints.EP_DOWNLOAD_WITHDRAWAL_DATA, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.records.length > 0){
					// credentials.localParams.parameter.downloadTransactions(result.res_data,"withdrawals");
					let arrayData = []
					for (let i = 0; i <= result.res_data.records.length - 1; i++) {
						let json = {
							'Client (UserName)' :  result.res_data.records[i].username,
							'Client (Trading ID)' :  result.res_data.records[i].account_id,
							'Date Requested' :   moment(result.res_data.records[i].created).format('DD-MM-YYYY'),
							'Currency' :  result.res_data.records[i].currency,
							'Amount Requested' :  result.res_data.records[i].amount,
							'Destination Address' :  result.res_data.records[i].address,

							'Withdrawal Status' :  credentials.localParams.parameter.depositWithdrawalPaymentStatus[parseInt(result.res_data.records[i].withdrawal_status)],
							'Withdrawal Method' :  credentials.localParams.parameter.withdrawalMethod[parseInt(result.res_data.records[i].withdrawal_method)],
							'Hash' :  result.res_data.records[i].crypto_tx_id.replace("#", ' ') 
						}
						arrayData.push(json)
		                if (i == result.res_data.records.length - 1) {
		                	console.log(arrayData)
		                	result.res_data['arrayData'] = arrayData
		                  credentials.localParams.parameter.downloadTransactions(result.res_data,"withdrawals");
		                }
		            }
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,'Record not found for applied criteria','error')
				}
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	// =========================== fee-history ====================================
	[Const.RUN_ADMIN_FEE_HISTORY]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_ADMIN_FEE_HISTORY, credentials,credentials.localParams.parameter,'',commit, (error, result)=>{
			if(!error){
				commit(Const.SET_FEE_HISTORY, result.res_data)
				
				setTimeout(() => {
  credentials.localParams.parameter.chartData4(result.res_data)
}, "3000");
				
			}else{
				commit(Const.SET_FEE_HISTORY, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	// =========================== Pricing ====================================
	[Const.RUN_GET_PRICING_PLAN_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_PRICING_PLAN_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_PRICING_PLAN_LIST, result.res_data)
			}else{
				commit(Const.SET_PRICING_PLAN_LIST, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_PRICING_PLAN_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_PRICING_PLAN_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_PRICING_PLAN_DETAIL, result.res_data)
					credentials.localParams.parameter.label = result.res_data.label
					credentials.localParams.parameter.description = result.res_data.description
					credentials.localParams.parameter.fee = result.res_data.fee
					credentials.localParams.parameter.fee_detail = (result.res_data.details != undefined && Object.keys(JSON.parse(result.res_data.details)).length > 0) ? 1 : 0

					if(Object.keys(JSON.parse(result.res_data.details)).length > 0 && parseInt(result.res_data.is_wallet) == 1){
						credentials.localParams.parameter.select_curr_wall_option = 'wallet_wise'
					}
					
				}else{
					commit(Const.SET_PRICING_PLAN_DETAIL, {})
				}
			}else{
				commit(Const.SET_PRICING_PLAN_DETAIL, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CREATE_PRICING_PLAN]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CREATE_PRICING_PLAN, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create plan successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_UPDATE_PRICING_PLAN]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_PRICING_PLAN, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$router.push({ path: '/plan-listing' })
				_messageDisplayFunction(credentials.localParams.parameter,'update plan successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_UPDATE_PRICING_PLAN_STATUS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_PRICING_PLAN_STATUS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.listing()
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'update status successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_UPDATE_CLIENT_PLAN]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_CLIENT_PLAN, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$parent.detail()
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'update status successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_GET_PRICING_OFFER_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_PRICING_OFFER_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_PRICING_OFFER_LIST, result.res_data)
			}else{
				commit(Const.SET_PRICING_OFFER_LIST, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_PRICING_OFFER_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_PRICING_OFFER_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_PRICING_OFFER_DETAIL, result.res_data)
					credentials.localParams.parameter.plan_type = result.res_data.plan_id
					credentials.localParams.parameter.offer_type = result.res_data.type
					credentials.localParams.parameter.code = result.res_data.code
					credentials.localParams.parameter.description = result.res_data.description
					credentials.localParams.parameter.time_period = result.res_data.time_period
					credentials.localParams.parameter.condition = result.res_data.offer_condition
					credentials.localParams.parameter.offer_from = result.res_data.offer_from
					credentials.localParams.parameter.offer_to= result.res_data.offer_to
				}else{
					commit(Const.SET_PRICING_OFFER_DETAIL, {})
				}
			}else{
				commit(Const.SET_PRICING_OFFER_DETAIL, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CREATE_PRICING_OFFER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CREATE_PRICING_OFFER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create offer successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_UPDATE_PRICING_OFFER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_PRICING_OFFER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$router.push({ path: '/offer-listing' })
				_messageDisplayFunction(credentials.localParams.parameter,'update offer successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_UPDATE_PRICING_OFFER_STATUS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_PRICING_OFFER_STATUS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.listing()
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'update status successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	// =========================== ROLES ====================================
	[Const.RUN_GET_ALL_ROLES]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ALL_ROLES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length > 0){
					commit(Const.SET_ALL_ROLES, result.res_data)
				}else{
					commit(Const.SET_ALL_ROLES, [])
				}
			}else{
				commit(Const.SET_ALL_ROLES, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_UPDATE_USER_ROLES]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_USER_ROLES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'update user role successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	// =========================== SETTINGS ====================================
	[Const.RUN_GET_USER_SETTING]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_USER_SETTING, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.getUserSetting = result.res_data
				if(result.res_data.length > 0 ){
					credentials.localParams.parameter.auto_conversion =  parseInt(result.res_data[0].auto_conversion)
					credentials.localParams.parameter.fiat_payout =  parseInt(result.res_data[0].fiat_payout)
					credentials.localParams.parameter.conversion =  parseInt(result.res_data[0].conversion)
				}else{
					credentials.localParams.parameter.auto_conversion = 0
					credentials.localParams.parameter.fiat_payout = 0
					credentials.localParams.parameter.conversion =  0
				}
			}else{
				credentials.localParams.parameter.getUserSetting = []
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_UPDATE_USER_SETTING]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_USER_SETTING, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'update user setting successfully','success')
				credentials.localParams.parameter.listing()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	//==========================================================================
	[Const.RUN_GET_DEPOSIT_WITHDRAW_DOWNLOAD]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DEPOSIT_WITHDRAW_DOWNLOAD, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length){
					var csv = 'deposit,user_id,account_id,currency,total_amount,amount,fee_percentage,deposit_fees,network_fee,created\n';
				    //merge the data with CSV
				    result.res_data.forEach(val => {
				            csv += '"' + (val.deposit || '-') + '",'
				            csv += '"' + (val.user_id || '-') + '",'
				            csv += '"' + (val.account_id || '-') + '",'
				            csv += '"' + (val.currency || '-') + '",'
				            csv += '"' + (val.total_amount || '0') + '",'
				            csv += '"' + (val.amount || '0') + '",'
				            csv += '"' + (val.fee_percentage || '0') + '",'
				            csv += '"' + (val.deposit_fees || '0') + '",'
				            csv += '"' + (val.network_fee || '0') + '",'
				            csv += '"' + (val.created || '-') + '"'
				            csv += "\n";  
				    });
				    var hiddenElement = document.createElement('a');  
				    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);  
				    hiddenElement.target = '_blank';
				    //provide the name for the CSV file to be downloaded  
				    hiddenElement.download = moment().format('DD-MM-YYYY')+'-transaction-list.csv';  
				    hiddenElement.click();
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,"No transaction's available",'error')
				}
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_DEPOSIT_TRANSFER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DEPOSIT_TRANSFER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.depositData['records'] = result.res_data
				credentials.localParams.parameter.depositData['totalRecords'] = result.res_data.length

			}else{
				credentials.localParams.parameter.depositData = []
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_CLIENT_REPORT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_CLIENT_REPORT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//let with_doc_link = getters[Const.GET_WITHDRAWAL_DOC_LINK];
				//let url = with_doc_link+credentials.localParams.process_type+'&id='+result.res_data+'&doc='+result.res_data ;
				
				window.open(result.res_data,'_blank');
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ALL_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ALL_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.internalNotes = result.res_data
			}else{
				credentials.localParams.parameter.internalNotes = {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	// =========================== WEB HOOKS ====================================
	[Const.RUN_GET_WEB_HOOKS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WEB_HOOKS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WEB_HOOKS, result.res_data)
			}else{
				commit(Const.SET_WEB_HOOKS, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_WEB_HOOKS_RETRY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_WEB_HOOKS_RETRY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				// _messageDisplayFunction(credentials.localParams.parameter,'otp has been sent in your given email id','success')
				credentials.localParams.parameter.listing()
				credentials.localParams.parameter.transaction_id = []
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//===============================request otp=================================================
	[Const.RUN_REQUEST_OTP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_REQUEST_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.submitted = false
				credentials.localParams.parameter.email = ''
				credentials.localParams.parameter.otpScreen = true
				credentials.localParams.parameter.trans_id = result.res_data.trans_id
				credentials.localParams.parameter.lead_id = result.res_data.lead_id
				_messageDisplayFunction(credentials.localParams.parameter,'otp has been sent in your given email id','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_VERIFY_OTP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_VERIFY_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.lead_id){
					credentials.localParams.parameter.$router.replace({name: 'client.clientView', query: {'id':result.res_data.lead_id}})
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data.msg,'error')
				}
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_SEND_EMAIL_USER]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SEND_MAIL,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,'send mail successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	//manage-group===============================================
	[Const.RUN_GET_MANAGE_GROUP_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_MANAGE_GROUP_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.groupList =  result.res_data
			}else{
				credentials.localParams.parameter.groupList =  {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let msz = "create";
				if(credentials.globalParams.group_id){
					msz = "edit"
				}
				credentials.localParams.parameter.$router.push({ path: '/group-listing' })
				_messageDisplayFunction(credentials.localParams.parameter,msz+' manage group successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	
	//task===============================================
	[Const.RUN_GET_TASK_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_TASK_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.taskList =  result.res_data
			}else{
				credentials.localParams.parameter.taskList =  {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_ADD_TASK]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADD_TASK,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'add task successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_TASK_UPDATE_STATUS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_TASK_UPDATE_STATUS,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.listing()
				_messageDisplayFunction(credentials.localParams.parameter,'update status successfully','success')
			}else{
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	
	//===========================================================
	[Const.RUN_SEND_WITH_DATA]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SEND_WITH_DATA,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let with_list = getters[Const.GET_WITHDRAWAL_LIST_MAKER];
				let withListArray = [];
				for(let i=0 ; i<=with_list.length-1 ; i++){
					if(credentials.localParams.parameter.roles.indexOf(with_list[i].id.toString()) == -1){
						withListArray.push(with_list[i])
					}
					if(i == with_list.length-1){
						if(withListArray.length == 0){
							credentials.localParams.parameter.record = false
							credentials.localParams.parameter.refetchRecordVar = true
						}else{credentials.localParams.parameter.refetchRecordVar = false}
						commit(Const.SET_WITHDRAWAL_LIST_MAKER, withListArray)
						credentials.localParams.parameter.roles = []
					}
				}
				_messageDisplayFunction(credentials.localParams.parameter,'Data Send successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	
	[Const.RUN_GET_WITHDRAWAL_LIST_MAKER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_LIST_MAKER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.refetchRecordVar = false
				commit(Const.SET_WITHDRAWAL_LIST_MAKER, result.res_data)
			}else{
				commit(Const.SET_WITHDRAWAL_LIST_MAKER, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_DOWNLOAD_FILES]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DOWNLOAD_FILES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let with_doc_link = getters[Const.GET_WITHDRAWAL_DOC_LINK];
				let url = with_doc_link+credentials.localParams.process_type+'&id='+result.res_data+'&doc='+result.res_data ;
				
				window.open(url,'_blank');
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
	[Const.RUN_GET_COUNTRIES_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COUNTRIES_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COUNTRIES_LIST, result.res_data)
			}else{
				commit(Const.SET_COUNTRIES_LIST, {})
			}
		})
  	},
	[Const.RUN_GET_CITIES_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_CITIES_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CITIES_LIST, result.res_data)
			}else{
				commit(Const.SET_CITIES_LIST,[])
			}
		})
  	},
//====================================coupon================================================
	[Const.RUN_CREATE_COUPON]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_CREATE_COUPON,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'coupon create successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_UNSUBSCRIBE]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_UNSUBSCRIBE,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'service unsubscribed successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_COUPON_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COUPON_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COUPON_LIST, result.res_data)
			}else{
				commit(Const.SET_COUPON_LIST,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_PLAN_COUPON_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_PLAN_COUPON_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.plan_coupon_list_array = result.res_data
			}else{
				credentials.localParams.parameter.plan_coupon_list_array = ''
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_SUB_EXSIST_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SUB_EXSIST_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_SUB_EXSIST_LIST, result.res_data)
			}else{
				commit(Const.SET_SUB_EXSIST_LIST,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_SUB_OPER]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SUB_OPER,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'An OTP has been sent on the registered email of client','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_SUB_PLAN_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SUB_PLAN_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_SUB_PLAN_LIST, result.res_data)
			}else{
				commit(Const.SET_SUB_PLAN_LIST,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_SUB_PLAN_DETAIL]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SUB_PLAN_DETAIL,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.subscri_detail = result.res_data
				commit(Const.SET_SUB_PLAN_DETAIL, result.res_data)
			}else{
				commit(Const.SET_SUB_PLAN_DETAIL,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
//====================================reporting=============================================
	[Const.RUN_CREATE_REPORT]({commit, state, dispatch,getters}, credentials){
		let API = ''
		if(credentials.localParams.report_status == '0'){
			API = Enpoints.EP_CREATE_COLLATERAL_PORTFOLIO
		}else if(credentials.localParams.report_status == '1'){
			API = Enpoints.EP_CREATE_EMIR_INSTRUMENTS
		}else if(credentials.localParams.report_status == '2'){
			API = Enpoints.EP_CREATE_MIFIR_INSTRUMENTS
		}else if(credentials.localParams.report_status == '3'){
			API = Enpoints.EP_CREATE_REPORTING_MEMBER
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create report successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_REPORTING_LIST]({commit, state, dispatch,getters}, credentials){
		let API = ''
		if(credentials.localParams.report_status == '0'){
			API = Enpoints.EP_GET_COLLATERAL_PORTFOLIO_LIST
		}else if(credentials.localParams.report_status == '1'){
			API = Enpoints.EP_GET_EMIR_INSTRUMENTS_LIST
		}else if(credentials.localParams.report_status == '2'){
			API = Enpoints.EP_GET_MIFIR_INSTRUMENTS_LIST
		}else if(credentials.localParams.report_status == '3'){
			API = Enpoints.EP_GET_REPORTING_MEMBER_LIST
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let cutColArray = []
				if(credentials.localParams.report_status == '1' && result.res_data.totalRecords > 0){
					for(let i=0 ; i<=result.res_data.records.length -1 ; i++){
						cutColArray[result.res_data.records[i].id] = {
							
							'Product_Classification':  result.res_data.records[i].Product_Classification,
							'Product_Identification_Type':  result.res_data.records[i].Product_Identification_Type,
							'Product_Identification':  result.res_data.records[i].Product_Identification,
							'Underlying_Type':  result.res_data.records[i].Underlying_Type,
							'Underlying_Id':  result.res_data.records[i].Underlying_Id,
							'Base_Currency':  result.res_data.records[i].Base_Currency,
							'Quote_Currency':  result.res_data.records[i].Quote_Currency,
							'Venue':  result.res_data.records[i].Venue,
							'Compressed_Trade':  result.res_data.records[i].Compressed_Trade,
							'Price_Notation':  result.res_data.records[i].Price_Notation,
							'Maturity_Date':  result.res_data.records[i].Maturity_Date,
							'Delivery_Type':  result.res_data.records[i].Delivery_Type,
							'Clearing':  result.res_data.records[i].Clearing,
							'Commodity_Base':  result.res_data.records[i].Commodity_Base,
							'Commodity_Details':  result.res_data.records[i].Commodity_Details,
							'Strike_Price_Notation':  result.res_data.records[i].Strike_Price_Notation,
							'Seniority':  result.res_data.records[i].Seniority,
							'Payment_Frequency':  result.res_data.records[i].Payment_Frequency,
							'Day_Count':  result.res_data.records[i].Day_Count,
							'Series':  result.res_data.records[i].Series,
							'Version':  result.res_data.records[i].Version,
							'Index_Factor':  result.res_data.records[i].Index_Factor,
							'Tranche':  result.res_data.records[i].Tranche,
							'Attachment_Point':  result.res_data.records[i].Attachment_Point,
							'Detachment_Point':  result.res_data.records[i].Detachment_Point,
							'Reference_Entity':  result.res_data.records[i].Reference_Entity,
							'Valuation_Market':  result.res_data.records[i].Valuation_Market,
							'Valuation_Symbol':  result.res_data.records[i].Valuation_Symbol
						}
						delete result.res_data.records[i]['Product_Classification']
						delete result.res_data.records[i]['Product_Identification_Type']
						delete result.res_data.records[i]['Product_Identification']
						delete result.res_data.records[i]['Underlying_Type']
						delete result.res_data.records[i]['Underlying_Id']
						delete result.res_data.records[i]['Base_Currency']
						delete result.res_data.records[i]['Quote_Currency']
						delete result.res_data.records[i]['Venue']
						delete result.res_data.records[i]['Compressed_Trade']
						delete result.res_data.records[i]['Price_Notation']
						delete result.res_data.records[i]['Maturity_Date']
						delete result.res_data.records[i]['Delivery_Type']
						delete result.res_data.records[i]['Clearing']
						delete result.res_data.records[i]['Commodity_Base']
						delete result.res_data.records[i]['Commodity_Details']
						delete result.res_data.records[i]['Strike_Price_Notation']
						delete result.res_data.records[i]['Seniority']
						delete result.res_data.records[i]['Payment_Frequency']
						delete result.res_data.records[i]['Day_Count']
						delete result.res_data.records[i]['Series']
						delete result.res_data.records[i]['Version']
						delete result.res_data.records[i]['Index_Factor']
						delete result.res_data.records[i]['Tranche']
						delete result.res_data.records[i]['Attachment_Point']
						delete result.res_data.records[i]['Detachment_Point']
						delete result.res_data.records[i]['Reference_Entity']
						delete result.res_data.records[i]['Valuation_Market']
						delete result.res_data.records[i]['Valuation_Symbol'] 
						if(i == result.res_data.records.length -1){
							credentials.localParams.parameter.column_array = cutColArray
							commit(Const.SET_REPORTING_LIST, result.res_data)
						}
					}
				}else if(credentials.localParams.report_status == '2' && result.res_data.totalRecords > 0){
					for(let i=0 ; i<=result.res_data.records.length -1 ; i++){
						cutColArray[result.res_data.records[i].id] = {
							'Notional_Currency_2':  result.res_data.records[i].Notional_Currency_2 ,
							'Instrument_Notional_Currency':  result.res_data.records[i].Instrument_Notional_Currency ,
							'Underlying_Index_Name':  result.res_data.records[i].Underlying_Index_Name ,
							'Underlying_Index_Term':  result.res_data.records[i].Underlying_Index_Term ,
							'Price_Multiplier':  result.res_data.records[i].Price_Multiplier ,
							'Quantity_Type':  result.res_data.records[i].Quantity_Type ,
							'Price_Notation_Type':  result.res_data.records[i].Price_Notation_Type ,
							'Underlying_Id':  result.res_data.records[i].Underlying_Id ,
							'Venue':  result.res_data.records[i].Venue ,
							'Maturity_Date':  result.res_data.records[i].Maturity_Date ,
							'Expiry_Date':  result.res_data.records[i].Expiry_Date ,
							'Delivery_Type':  result.res_data.records[i].Delivery_Type ,
							'Strike_Price_Notation_Type':  result.res_data.records[i].Strike_Price_Notation_Type
						}
						delete result.res_data.records[i]['Notional_Currency_2']
						delete result.res_data.records[i]['Instrument_Notional_Currency']
						delete result.res_data.records[i]['Underlying_Index_Name']
						delete result.res_data.records[i]['Underlying_Index_Term']
						delete result.res_data.records[i]['Price_Multiplier']
						delete result.res_data.records[i]['Quantity_Type']
						delete result.res_data.records[i]['Price_Notation_Type']
						delete result.res_data.records[i]['Underlying_Id']
						delete result.res_data.records[i]['Venue']
						delete result.res_data.records[i]['Maturity_Date']
						delete result.res_data.records[i]['Expiry_Date']
						delete result.res_data.records[i]['Delivery_Type']
						delete result.res_data.records[i]['Strike_Price_Notation_Type']
						
						if(i == result.res_data.records.length -1){
							credentials.localParams.parameter.mifirColumn_array = cutColArray
							commit(Const.SET_REPORTING_LIST, result.res_data)
						}
					}
				}else{
					commit(Const.SET_REPORTING_LIST, result.res_data)
				}
			}else{
				commit(Const.SET_REPORTING_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
//====================================email=================================================
	[Const.RUN_EMAIL_SETTING_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_EMAIL_SETTING_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_EMAIL_SETTING_LIST, result.res_data)
			}else{
				commit(Const.SET_EMAIL_SETTING_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_ADD_EMAIL_SETTING]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_EMAIL_SETTING, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create email successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_GET_NOTIFICATION_LIST]({commit, state,getters,dispatch}, credentials){
  		// alert(1)
		_executeApi(Enpoints.EP_GET_NOTIFICATION_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				// alert('true')
				if(credentials.globalParams.read == "0"){
					commit(Const.SET_NOTIFICATION_UNREAD_LIST, result.res_data)
				} else if (credentials.globalParams.read == "1"){
					commit(Const.SET_NOTIFICATION_READ_LIST, result.res_data)
				} else {
					commit(Const.SET_NOTIFICATION_LIST, result.res_data)
				}
			}else{
				// alert('false')
				// commit(Const.SET_NOTIFICATION_LIST, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_READ_UNREAD_NOTIFICATION]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_READ_UNREAD_NOTIFICATION, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.afterUnread()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================admin=================================================
	[Const.RUN_GET_ADMIN_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ADMIN_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.totalRecords > 0){
					for(let i=0 ; i<=result.res_data.records.length -1 ; i++){
						if(result.res_data.records[i].roles){
							result.res_data.records[i].role_array = result.res_data.records[i].roles.split(',')
						}else{
							result.res_data.records[i].role_array = []
						}
						
						if(i == result.res_data.records.length -1){
							commit(Const.SET_ADMIN_LIST, result.res_data)
						}
					} 
				}else{
					commit(Const.SET_ADMIN_LIST, result.res_data)
				}
			}else{
				commit(Const.SET_ADMIN_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ADMIN_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ADMIN_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_ADMIN_DETAIL, result.res_data[0])
			}else{
				commit(Const.SET_ADMIN_DETAIL, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_ADD_ADMIN]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_ADMIN, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create admin successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_UPDATE_ADMIN_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_ADMIN_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			credentials.localParams.parameter.showEditConfirm = '0'
			if(!error){
				if(credentials.localParams.type == 'email'){
					credentials.localParams.parameter.email = ''
					credentials.localParams.parameter.emailEdit = false
				}else if(credentials.localParams.type == 'role'){
					credentials.localParams.parameter.role = []
					credentials.localParams.parameter.roleEdit = false
				}else if(credentials.localParams.type == 'accuracy'){
					credentials.localParams.parameter.accuracy = ''
					credentials.localParams.parameter.accuracyEdit = false
				}else if(credentials.localParams.type == 'password'){
					credentials.localParams.parameter.password = ''
					credentials.localParams.parameter.passwordEdit = false
				}else if(credentials.localParams.type == 'name'){
					credentials.localParams.parameter.fname = ''
					credentials.localParams.parameter.lname = ''
					credentials.localParams.parameter.time_in = ''
					credentials.localParams.parameter.time_out = ''
					credentials.localParams.parameter.country = ''
					credentials.localParams.parameter.nameEdit = false
				}else if(credentials.localParams.type == 'mobile'){
					credentials.localParams.parameter.mobile = ''
					credentials.localParams.parameter.mobileEdit = false
				}
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_CHANGE_PASSWORD]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_RESET_PASS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.clearAll()
				_messageDisplayFunction(credentials.localParams.parameter,'update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//=====================================faq==================================================
	[Const.RUN_CREATE_CATEGORY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_CATEGORY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.module == 'edit'){
					credentials.localParams.parameter.$router.push({ path: '/category-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'edit category successfully','success')
				}else{
					credentials.localParams.parameter.reset()
					_messageDisplayFunction(credentials.localParams.parameter,'create category successfully','success')
				}
			}else{
				if(credentials.localParams.module != 'edit'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CREATE_ARTICLE]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_ARTICLE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.module == 'edit'){
					credentials.localParams.parameter.$router.push({ path: '/articles-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'edit article successfully','success')
				}else{
					credentials.localParams.parameter.reset()
					_messageDisplayFunction(credentials.localParams.parameter,'create article successfully','success')
				}
			}else{
				if(credentials.localParams.module != 'edit'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ARTICLE_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ARTICLE_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_ARTICLE_LIST, result.res_data)
			}else{
				commit(Const.SET_ARTICLE_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_CAT_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_CAT_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CAT_LIST, result.res_data)
			}else{
				commit(Const.SET_CAT_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ARTICLE_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ARTICLE_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.art_name = result.res_data[0].articleName
				credentials.localParams.parameter.art_desc = result.res_data[0].description
				credentials.localParams.parameter.categoryId = result.res_data[0].categoryId
				credentials.localParams.parameter.category = result.res_data[0].catSlug
				credentials.localParams.parameter.status = result.res_data[0].status
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_CAT_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_CAT_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.cat_name = result.res_data[0].name
				credentials.localParams.parameter.cat_desc = result.res_data[0].description
				credentials.localParams.parameter.status = result.res_data[0].status
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_DELETE_ARTICLEL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DELETE_ARTICLE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let msg = ((credentials.globalParams.status == 1)?'Enabled':'Disabled')+' Article Successfull'
				_messageDisplayFunction(credentials.localParams.parameter,msg,'success')
				credentials.localParams.parameter.listing()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_DELETE_CATEGORY]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DELETE_CATEGORY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let msg = ((credentials.globalParams.status == 1)?'Enabled':'Disabled')+' category Successfull'
				_messageDisplayFunction(credentials.localParams.parameter,msg,'success')
				credentials.localParams.parameter.listing()
			}else{
				
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},


//====================================client=================================================
	[Const.RUN_WITHDRAWAL_METHODS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_WITHDRAWAL_METHODS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, result.res_data)
				let json ={} , count =0 ;
				for(var key in result.res_data){
					count++
					json[key] = {}
					let count1 = 0
					for(var innerkey in result.res_data[key]){
						count1++
						json[key][result.res_data[key][innerkey].id] = result.res_data[key][innerkey]
						if(count1 == Object.keys(result.res_data[key]).length){
							//console.log(json)
						}
					}
					if(count == Object.keys(result.res_data).length){
						commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE,json)
					}
				}
			}else{
				commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
//list and detail
	[Const.RUN_USER_COUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_COUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_USER_COUNT, result.res_data)
			}else{
				commit(Const.SET_USER_COUNT, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_USER_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_USER_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.page == 'search'){
					credentials.localParams.parameter.searchData = result.res_data
				}else{
					commit(Const.SET_USER_LIST, result.res_data)
				}
			}else{
				if(credentials.localParams.page == 'search'){
					credentials.localParams.parameter.searchData = []
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}else{
					commit(Const.SET_USER_LIST, [])
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}
				
			}
		}) 
  	},
	[Const.RUN_GET_LOGS_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_LOGS_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOGS_LIST, result.res_data)
			}else{
				commit(Const.SET_LOGS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_LOGS_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_LOGS_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOGS_VIEW, result.res_data[0])
			}else{
				commit(Const.SET_LOGS_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_LOGS_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_LOGS_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.globalParams.type && credentials.globalParams.type != undefined){
					commit(Const.SET_EMAIL_DATA, result.res_data.details)
				}else{
					let logDataJsonArray = [] 
					credentials.localParams.parameter.logsDetailTab = '1'
					if(result.res_data.details.length > 0){
						for (var threadkey = 0; threadkey < result.res_data.details.length; threadkey++) {
							logDataJsonArray.push(JSON.parse(result.res_data.details[threadkey]))
							if(result.res_data.details.length-1 == threadkey){
								credentials.localParams.parameter.logsDetail = logDataJsonArray
							}
						}
					}else{
						credentials.localParams.parameter.logsDetail = []
					}
				}
			}else{
				if(credentials.globalParams.type && credentials.globalParams.type != undefined){
					commit(Const.SET_EMAIL_DATA, [])
				}else{
					credentials.localParams.parameter.logsDetail = []
					credentials.localParams.parameter.logsDetailTab = ''
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_UPDATE_CLIENT_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_CLIENT_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(credentials.localParams.page == 'view'){  credentials.localParams.parameter.showEditConfirm = '0'  }
			
			if(!error){
				
				if(credentials.localParams.type == 'address'){
					credentials.localParams.parameter.addressEdit = false
					credentials.localParams.parameter.address1 = ''
					credentials.localParams.parameter.address2 = ''
					credentials.localParams.parameter.pincode = ''
					credentials.localParams.parameter.city = ''
					credentials.localParams.parameter.residence_country = ''
					credentials.localParams.parameter.nationality = ''
					credentials.localParams.parameter.addKey = false
				}else if(credentials.localParams.type == 'email'){
					credentials.localParams.parameter.emailEdit = false
                    credentials.localParams.parameter.email = ''
					credentials.localParams.parameter.emailKey = false
                }else if(credentials.localParams.type == 'financial'){
					credentials.localParams.parameter.financialEdit = false
                    credentials.localParams.parameter.emp_status = ''
                    credentials.localParams.parameter.occupation1 = ''
                    credentials.localParams.parameter.yearly_income = ''
                    credentials.localParams.parameter.net_worth = ''
                    credentials.localParams.parameter.account_turnover  = ''
					credentials.localParams.parameter.finKey = false					
                }else if(credentials.localParams.type == 'client'){
					credentials.localParams.parameter.clientEdit = false
                    credentials.localParams.parameter.fname = ''
                    credentials.localParams.parameter.lname = ''
                    credentials.localParams.parameter.mobile_no = ''
                    credentials.localParams.parameter.gender  = ''
                    credentials.localParams.parameter.dob    = ''
					credentials.localParams.parameter.clientKey = false					
                }else if(credentials.localParams.type == 'STEP'){
					credentials.localParams.parameter.step = ''
					credentials.localParams.parameter.stepEdit = false
					credentials.localParams.parameter.stepKey = false
				}else if(credentials.localParams.type == 'PRO_STATUS'){
					credentials.localParams.parameter.step = ''
					credentials.localParams.parameter.proEdit = false
					credentials.localParams.parameter.proUser = false
				}else if(credentials.localParams.type == 'RISKMETRIX'){
					credentials.localParams.parameter.identification = ''
					credentials.localParams.parameter.fund_source = ''
					credentials.localParams.parameter.deposit_method = ''
					credentials.localParams.parameter.credit_institution = ''
					credentials.localParams.parameter.channel_risk = ''
					credentials.localParams.parameter.third_party = ''
					credentials.localParams.parameter.otherKey = false
					credentials.localParams.parameter.otherEdit = false
				}else if(credentials.localParams.type == 'OTHER_INFO'){
					credentials.localParams.parameter.pep = ''
					credentials.localParams.parameter.sanction_risk = ''
					credentials.localParams.parameter.adverse_media = ''
					credentials.localParams.parameter.P_IDNUMBER = ''
					credentials.localParams.parameter.CRSNUMBER = ''
					credentials.localParams.parameter.tax_residency = ''
					credentials.localParams.parameter.id_type = ''
					credentials.localParams.parameter.otherInfoEdit = false
				}else if(credentials.localParams.type == 'LEAD_TYPE'){
					credentials.localParams.parameter.lead_type = ''
					credentials.localParams.parameter.submitted = false
					credentials.localParams.parameter.editLeadList = {}
				}else if(credentials.localParams.type == 'RM'){
					credentials.localParams.parameter.rm_type = ''
					credentials.localParams.parameter.submitted = false
					credentials.localParams.parameter.editRmList = {}
				}   
				if(credentials.localParams.page == 'view'){  
					credentials.localParams.parameter.detail() 
				}else{
					credentials.localParams.parameter.listing()
				}
				
				_messageDisplayFunction(credentials.localParams.parameter,'update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_USER_VIEW]({commit, state,getters,dispatch}, credentials){
		
		_executeApi(Enpoints.EP_GET_USER_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_USER_VIEW, result.res_data[0])
				credentials.localParams.parameter.editPermissionFunc()
				if(credentials.localParams.page && credentials.localParams.page == 'createPdf'){
					credentials.localParams.parameter.$router.push({ path: '/clientpdf', query:{ "id" : credentials.globalParams.user_id } })
				}else{
					credentials.localParams.parameter.$router.push({ path: '/view', query: { "id" : credentials.globalParams.user_id } })
				}
				
			}else{
				commit(Const.SET_USER_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CLOSE_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CLOSE_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'close account successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//reset password
  	[Const.RUN_RESET_PASSWORD]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_RESET_PASSWORD, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.resetPasswordConfirm = false
				_messageDisplayFunction(credentials.localParams.parameter,'password reset successfully','success')
			}else{
				credentials.localParams.parameter.resetPasswordConfirm = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//create activity
  	[Const.RUN_CREATE_ACTIVITY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_ACTIVITY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'create activity successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//get activity
  	[Const.RUN_GET_ACTIVITY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ACTIVITY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOGS_LIST, result.res_data)
			}else{
				commit(Const.SET_LOGS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//verify account
  	[Const.RUN_VERIFY_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_VERIFY_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.verifyAccount = false
				_messageDisplayFunction(credentials.localParams.parameter,'verify account successfully','success')
			}else{
				credentials.localParams.parameter.verifyAccount = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//disable
	[Const.RUN_DISABLE2FA]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DISABLE2FA, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.disable2Fa = false
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'disable 2FA successfully','success')
			}else{
				credentials.localParams.parameter.disable2Fa = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//notification
  	[Const.RUN_USER_NOTIFICATIONS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_NOTIFICATIONS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//commit(Const.SET_USER_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({ path: '/view', query: { "id" : credentials.globalParams.user_id } })
			}else{}
		}) 
  	},
//internal note
  	[Const.RUN_ADD_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'add internal note successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_EDIT_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_EDIT_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'edit internal note successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_DELETE_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DELETE_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'delete internal note successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_INTERNAL_NOTES, result.res_data)
			}else{
				commit(Const.SET_INTERNAL_NOTES, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//get risk metrix
	[Const.RUN_GET_RISK_METRIX]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_RISK_METRIX, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_RISK_METRIX, result.res_data)
			}else{
				commit(Const.SET_RISK_METRIX, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
	[Const.RUN_ALLOW_FOR_IPV]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ALLOW_FOR_IPV, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'ipv allow successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

//====================================ticket=================================================
	[Const.RUN_CREATE_WALLET]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_WALLET, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				credentials.localParams.parameter.buttonDiv = false
				_messageDisplayFunction(credentials.localParams.parameter,'create wallet successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_CREATE_ACT_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_ACT_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				credentials.localParams.parameter.buttonDiv = false
				_messageDisplayFunction(credentials.localParams.parameter,'create act account successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_ADD_TICKET]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_TICKET, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.congModule = true
				credentials.localParams.parameter.$parent.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create ticket successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_TICKET_TRANSFER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_TRANSFER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.$router.push({ path: '/ticket-list' })
				_messageDisplayFunction(credentials.localParams.parameter,'ticket transfer successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CLOSE_TICKET]({commit, state,getters,dispatch}, credentials){
		let API;
		if(parseInt(credentials.localParams.reason) == 8){
  			API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
			//credentials.globalParams.status = '0' 
  		}else{
			API = Enpoints.EP_CLOSE_TICKET
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.module == 'withdrawal'){
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.listing()
					_messageDisplayFunction(credentials.localParams.parameter,'reject data successfully','success')
				}else if(credentials.localParams.module == 'reject'){
					credentials.localParams.parameter.ticketDetail()
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$router.push({ path: '/ticket-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'reject ticket successfully','success')
				}else{
					credentials.localParams.parameter.ticketDetail()
					credentials.localParams.parameter.$router.push({ path: '/ticket-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'close ticket successfully','success')
				}
			}else{
				if(credentials.localParams.module == 'reject'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TICKET_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TICKET_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TICKET_LIST, result.res_data)

			}else{
				commit(Const.SET_TICKET_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_TICKET_REASON_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_TICKET_REASON_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TICKET_REASON_LIST, result.res_data)
			}else{
				commit(Const.SET_TICKET_REASON_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TICKET_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TICKET_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let doc_array = [], i=0 ;
				if((typeof result.res_data.threads !== 'undefined') && (result.res_data.threads.length >0)){
					for (var threadkey = 0; threadkey < result.res_data.threads.length; threadkey++) {
						if(result.res_data.threads[threadkey].docs.length > 0){
							for (var dockey = 0; dockey < result.res_data.threads[threadkey].docs.length; dockey++) {
								doc_array.push(result.res_data.threads[threadkey].docs[dockey])
								if(parseInt(result.res_data.threads[threadkey].docs[dockey].status) == 0){
							    	i = 1
							  	}
							}
						}
					  	if(result.res_data.threads.length-1 == threadkey){
					  		if(i == 1){ 
						      result.res_data.approve_flag = false;
						    }else{ 
						      result.res_data.approve_flag = true;
						    }
							//console.log('result.res_data----',result.res_data)
						    commit(Const.SET_TICKET_VIEW, result.res_data)
						    commit(Const.SET_TICKET_DOCS, doc_array)
						}
					}
				}else{
					result.res_data.approve_flag = true;
					commit(Const.SET_TICKET_VIEW, result.res_data)
				    commit(Const.SET_TICKET_DOCS, doc_array)
				}
				//credentials.localParams.parameter.$router.push({ path: '/ticket-view', query: { "id" : credentials.globalParams.ticket_id } })
			}else{
				commit(Const.SET_TICKET_VIEW, [])
				commit(Const.SET_TICKET_DOCS, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_GET_TICKET_REASON_LIST]({commit, state,getters,dispatch}, credentials){	
  		
		_executeApi(Enpoints.EP_GET_TICKET_REASON_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){

				let ticketData = _ticketFunction(result.res_data)
				commit(Const.SET_TICKET_DATA, ticketData)
				let count = 0
				for(var key in  result.res_data){
					//count++
					if(result.res_data[key].categories && result.res_data[key].categories != undefined && result.res_data[key].categories.length >0){
						let categoriesList = {}
						let innerCount = 0
						for(let i=0; i<= result.res_data[key].categories.length-1 ; i++){
							
							categoriesList[result.res_data[key].categories[i].id] = result.res_data[key].categories[i]
							innerCount++
							if(innerCount == result.res_data[key].categories.length){
								delete result.res_data[key].categories
								result.res_data[key]['categories'] = categoriesList
								count++
							}
						}
					}else{
						count++
					}
					if(count == Object.keys(result.res_data).length){
						commit(Const.SET_TICKET_REASON_LIST2, result.res_data)
						
					}
				}
				
			}else{
				commit(Const.SET_TICKET_REASON_LIST2, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_TICKET_REPLY]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_REPLY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'message sent successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_TICKET_APPROVE]({commit, state,getters,dispatch}, credentials){
  		let API;
  		if(parseInt(credentials.localParams.reason) == 1 && parseInt(credentials.localParams.title) == 15){
  			API = Enpoints.EP_TICKET_APPROVE_USER
  		}else if(parseInt(credentials.localParams.reason) == 8){
  			API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
			credentials.globalParams.status = '1'
  		}else{
			API = Enpoints.EP_TICKET_APPROVE
  		}	

  // 		else if (parseInt(credentials.localParams.reason) == 115){
		// 	API = Enpoints.EP_TICKET_APPROVE
		// }
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				credentials.localParams.parameter.$router.push({ path: '/ticket-list' })
				_messageDisplayFunction(credentials.localParams.parameter,'ticket approve successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_TICKET_DOC_APPROVE_REJECT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_DOC_APPROVE_REJECT, credentials,credentials.localParams.parameter.$parent,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.clear()
				credentials.localParams.parameter.$parent.ticketDetail()
				if(credentials.globalParams.status == '1'){
					_messageDisplayFunction(credentials.localParams.parameter,'document reject successfully','success')
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,'documents successfully','success')
				}
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_ESCALTE_TICKET]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_ESCALTE_TICKET, credentials,credentials.localParams.parameter.$parent,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.page == 'ticket_list'){
					credentials.localParams.parameter.roles = []
					credentials.localParams.parameter.listing()
					_messageDisplayFunction(credentials.localParams.parameter,'ticket escalate successfully','success')
				}else if(credentials.localParams.page == '2'){  
					credentials.localParams.parameter.ticketDetail() 
					_messageDisplayFunction(credentials.localParams.parameter,'ticket escalate successfully','success')
				}else{
					credentials.localParams.parameter.ticketDetail() 
					_messageDisplayFunction(credentials.localParams.parameter,'ticket deescalate successfully','success')
				}
				
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_TICKET_APPROVE_MULTIPLE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_APPROVE_MULTIPLE, credentials,credentials.localParams.parameter.$parent,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.listing()
				credentials.localParams.parameter.roles = []
				_messageDisplayFunction(credentials.localParams.parameter,'ticket approve successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_GROUP_ADMIN_NAME]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_GROUP_ADMIN_NAME, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_GROUP_ADMIN_NAME, result.res_data)
				let count = 0 ;
				let json= {};
				if(Object.keys(result.res_data).length > 0){
					for(var key in result.res_data){
						count++
						for(let i=0 ; i<=result.res_data[key].length -1 ; i++){
							if((Object.keys(json).length == 0)  || !(json.hasOwnProperty(result.res_data[key][i].ID))){
								json[result.res_data[key][i].ID] = []
							}
							json[result.res_data[key][i].ID].push(key)
						}
						if(count == Object.keys(result.res_data).length){
							commit(Const.SET_USER_GROUP_ID, json)
						}
					}
				}else{
					commit(Const.SET_USER_GROUP_ID, [])
				}
				
				if(credentials.localParams.page == 'add-edit'){
					credentials.localParams.parameter.rmlistFunc()
				}
			}else{
				commit(Const.SET_GROUP_ADMIN_NAME, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================deposit================================================
	[Const.RUN_DEPOSIT_UPDATE_SUSPENSE]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DEPOSIT_UPDATE_SUSPENSE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.clearAll()
				_messageDisplayFunction(credentials.localParams.parameter,'deposit update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_DEPOSIT_ASSIGN]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DEPOSIT_ASSIGN, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.clearAll()
				credentials.localParams.parameter.roles = []
				credentials.localParams.parameter.ticketReason1 = '114'
				credentials.localParams.parameter.tab = '2'
				credentials.localParams.parameter.listing()
				_messageDisplayFunction(credentials.localParams.parameter,'update Suspense Ticket Reason successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_DEPOSIT_UPLOAD]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DEPOSIT_UPLOAD, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'deposit file upload successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CREATE_DEPOSIT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_DEPOSIT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'create deposit successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_DEPOSIT_TRANSACTION_STATUS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_DEPOSIT_TRANSACTION_STATUS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.trans_hitory = result.res_data
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_DEPOSIT_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DEPOSIT_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_DEPOSIT_LIST, result.res_data)
			}else{
				commit(Const.SET_DEPOSIT_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_DEPOSIT_FAILED_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DEPOSIT_FAILED_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.records.length > 0){
					// credentials.localParams.parameter.downloadTransactions(result.res_data,"withdrawals");
					if(credentials.localParams.parameter.showDownloadHistoryFlag == true){
						let arrayData = []
						for (let i = 0; i <= result.res_data.records.length - 1; i++) {
							let json = {
								'Act User Name' : result.res_data.records[i].act_user_name,
								'Currency' :  result.res_data.records[i].currency,
								// 'Errors' : (result.res_data.records[i].errors).replaceAll(',','|'),
								'Hash' : result.res_data.records[i].hash,
								'Reason Text' :  (result.res_data.records[i].reason_text).replaceAll(',','|'),
								'Transfer' : result.res_data.records[i].transfer,
								'Created' :  moment(result.res_data.records[i].created).format('DD-MM-YYYY'),
								
							}
							arrayData.push(json)
			                if (i == result.res_data.records.length - 1) {
			                	result.res_data['arrayData'] = arrayData
			                  credentials.localParams.parameter.downloadTransactions(result.res_data,"Failed Deposits");
			                }
			            }
					}else{
						credentials.localParams.parameter.failedDepositList = result.res_data
					}
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,'Record not found for applied criteria','error')
				}
				// console.log('------------------>',result.res_data)
				// if(result.res_data.length){
				// 	var csv = 'Transfer,Hash,Address,Total_amount,Amount,Currency,Usd_amount,Wallet,Reason,Reason_text,Created,Errors\n';
				//     //merge the data with CSV
				//     result.res_data.forEach(val => {
				//             csv += '"' + (val.transfer || '-') + '",'
				//             csv += '"' + (val.hash || '-') + '",'
				//             csv += '"' + (val.address || '-') + '",'
				//             csv += '"' + (val.total_amount || '0') + '",'
				//             csv += '"' + (val.amount || '0') + '",'
				//             csv += '"' + (val.currency || '-').toUpperCase() + '",'
				//             csv += '"' + (val.usd_amount || '0') + '",'
				//             csv += '"' + (val.wallet || '-') + '",'
				//             csv += '"' + (val.reason || '-') + '",'
				//             csv += '"' + (val.reason_text || '-').replaceAll(',','\,').replaceAll('"',"`") + '",'
				//             csv += '"' + (val.created || '-') + '",'
				//             csv += '"' + (val.errors || '-').replaceAll(',','\,').replaceAll('"',"`") + '"'
				//             csv += "\n";  
				//     });
				//     var hiddenElement = document.createElement('a');  
				//     hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);  
				//     hiddenElement.target = '_blank';
				//     //provide the name for the CSV file to be downloaded  
				//     hiddenElement.download = moment().format('DD-MM-YYYY')+'-failed-transaction-list.csv';  
				//     hiddenElement.click();
				// }else{
				// 	_messageDisplayFunction(credentials.localParams.parameter,"No transaction's available",'error')
				// }
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_DEPOSIT_VIEW]({commit, state,getters,dispatch}, credentials){		
		_executeApi(Enpoints.EP_GET_DEPOSIT_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_DEPOSIT_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({path: '/deposit-view',query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_DEPOSIT_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_EDIT_DEPOSIT_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_DEPOSIT_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
//====================================withdrawal=============================================
	[Const.RUN_ADD_WITHDRAWAL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_WITHDRAWAL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create withdrawal successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ACCOUNT_DETAIL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ACCOUNT_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.balance = result.res_data.balance
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_WITHDRAWAL_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WITHDRAWAL_LIST, result.res_data)
			}else{
				commit(Const.SET_WITHDRAWAL_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
	[Const.RUN_GET_WITHDRAWAL_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WITHDRAWAL_VIEW, result.res_data)
				//credentials.localParams.parameter.$router.push({ path: '/withdrawal-view', query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_WITHDRAWAL_VIEW, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_EDIT_WITHDRAWAL_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_WITHDRAWAL_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit,(error, result)=>{
			if(!error){
				credentials.localParams.parameter.edit_detail = false
			}
		}) 
  	},
  	[Const.CALL_USER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.CALL_USER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit,(error, result)=>{
			if(error){
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	
//====================================bonus=============================================
	[Const.RUN_GET_BONUS_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_BONUS_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_BONUS_LIST, result.res_data)
			}else{
				commit(Const.SET_BONUS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_BONUS_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_BONUS_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_BONUS_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({ path: '/bonus-view', query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_BONUS_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================trading================================================
	[Const.RUN_CREATE_TRADING_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_TRADING_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create trading account successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TRADING_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_TRADING_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TRADING_LIST, result.res_data)
			}else{
				commit(Const.SET_TRADING_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TRADING_ORDERS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_TRADING_ORDERS, credentials, credentials.localParams.parameter, {'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TRADING_ORDERS, result.res_data)
			}else{
				commit(Const.SET_TRADING_ORDERS, { cancel_orders:[], filled_orders:[], open_orders:[] })
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TRADING_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TRADING_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TRADING_VIEW, result.res_data)
				// commit(Const.SET_TRADING_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({ path: '/trading-view', query: { "id" : credentials.globalParams.id } })
			}else{
				commit(Const.SET_TRADING_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_EDIT_TRADING_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_TRADING_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.edit_detail = false
			}
		}) 
  	},
	[Const.RUN_CHANGE_LEVERAGE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CHANGE_LEVERAGE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.leverageEdit = false
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'change leverage successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	/*[Const.RUN_DELETE_TRADING_ACCOUNT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DELETE_TRADING_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//credentials.localParams.parameter.edit_detail = false
			}
		}) 
  	},*/

  	[Const.RUN_GET_CLIENT_DATA]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_CLIENT_DATA, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CLIENT_DATA, result.res_data)
			}else{
				commit(Const.SET_CLIENT_DATA, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_ORDER_HISTORY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ORDER_HISTORY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length > 0){
					let open = [], cancle = [], filled = [], sumData = [];
					result.res_data.forEach(val =>{
						for(let data in val){

							if(parseInt(val[data].is_social) == 0){
								if (Array.isArray(val[data].orderHistory.open_orders)) {
				                    val[data].orderHistory.open_orders.forEach(val => {
				                        let data = val
				                        data.Status = 'CREATED'
				                        data['sortDate'] = data.Opened
				                        if(data.OrderType == 'SL'){
				                            let stop = JSON.parse(JSON.stringify(data))
				                            let limit = JSON.parse(JSON.stringify(data))
				                            stop['OrderType'] = 'S'
				                            stop['Price'] = 0
				                            limit['OrderType'] = 'L'
				                            limit['StopPrice'] = 0
				                            open.push(stop)
				                            open.push(limit)
				                        }else{
				                            open.push(data)
				                        }
				                    })
				                }
				                if (Array.isArray(val[data].orderHistory.cancel_orders)) {
				                    cancle = val[data].orderHistory.cancel_orders.map(val => {
				                        let data = val
				                        data.Status = 'CANCELED'
				                        data['sortDate'] = data.Canceled
				                        return data
				                    })
				                }
				                if (Array.isArray(val[data].orderHistory.filled_orders)) {
				                    filled = val[data].orderHistory.filled_orders.map(val => {
				                        let data = val
				                        data.Status = 'FILLED'
				                        data['sortDate'] = data.Closed
				                        return data
				                    })
				                }
				                let allData = open.concat(cancle).concat(filled)
				                allData.sort((a, b) => {
				                    return Date.parse(b.sortDate) - Date.parse(a.sortDate)
				                })
				                var openlist = allData.filter(val => val.Status == 'CREATED')
				                var canclelist = allData.filter(val => val.Status == 'CANCELED')
				                var filledlist = allData.filter(val => val.Status == 'FILLED')

				                let stateData = {
				                    records: allData,
				                    totalRecords: { 'open': openlist.length, 'cancel': canclelist.length, 'filled': filledlist.length,'totalRecords' : allData.length }
				                }
				                commit(Const.SET_ORDER_HISTORY, stateData)

							}
							if(parseInt(val[data].is_social) == 1){
								if (Array.isArray(val[data].orderHistory.open_orders)) {
				                    val[data].orderHistory.open_orders.forEach(val => {
				                        let data = val
				                        data.Status = 'CREATED'
				                        data['sortDate'] = data.Opened
				                        if(data.OrderType == 'SL'){
				                            let stop = JSON.parse(JSON.stringify(data))
				                            let limit = JSON.parse(JSON.stringify(data))
				                            stop['OrderType'] = 'S'
				                            stop['Price'] = 0
				                            limit['OrderType'] = 'L'
				                            limit['StopPrice'] = 0
				                            open.push(stop)
				                            open.push(limit)
				                        }else{
				                            open.push(data)
				                        }
				                    })
				                }
				                if (Array.isArray(val[data].orderHistory.cancel_orders)) {
				                    cancle = val[data].orderHistory.cancel_orders.map(val => {
				                        let data = val
				                        data.Status = 'CANCELED'
				                        data['sortDate'] = data.Canceled
				                        return data
				                    })
				                }
				                if (Array.isArray(val[data].orderHistory.filled_orders)) {
				                    filled = val[data].orderHistory.filled_orders.map(val => {
				                        let data = val
				                        data.Status = 'FILLED'
				                        data['sortDate'] = data.Closed
				                        return data
				                    })
				                }
				                let allData = open.concat(cancle).concat(filled)
				                allData.sort((a, b) => {
				                    return Date.parse(b.sortDate) - Date.parse(a.sortDate)
				                })
				                var openlist = allData.filter(val => val.Status == 'CREATED')
				                var canclelist = allData.filter(val => val.Status == 'CANCELED')
				                var filledlist = allData.filter(val => val.Status == 'FILLED')

				                let stateData = {
				                    records: allData,
				                    totalRecords: { 'open': openlist.length, 'cancel': canclelist.length, 'filled': filledlist.length,'totalRecords' : allData.length }
				                }
				                commit(Const.SET_ORDER_HISTORY_SOCIAL_DATA, stateData)
							}
						}
					})
	                
					
				}else{
					commit(Const.SET_ORDER_HISTORY, {})
					commit(Const.SET_ORDER_HISTORY_SOCIAL_DATA, {})
				}
			}else{
				commit(Const.SET_ORDER_HISTORY, {})
				commit(Const.SET_ORDER_HISTORY_SOCIAL_DATA, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
}

//------------------------------------------------------Functions------------------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
 	commit("SET_INFO", msg)
}
function _handleErrorResponse(e, commit) {
  	let response = {info: 'NOK', msg: 'Service not available'}
  	if (typeof e.response === 'undefined') {
    	try {
      		const statusCheck = e.toString().toLowerCase()
	      	if (statusCheck.indexOf('network') > -1) {
	        	response = {info: 'NOK', msg: 'Network Error'}
	      	}
    	} catch (e) {}
  	} else {
    	response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if(typeof e.response !== 'undefined'){
		if(e.response.status == 401){
 			let data = {}
			let options = {}
			options.forward = true
	 		_handleLogout(data, commit, options)
	 	}
	}
}
function _handleLogout (data, commit, options) {
	let user = {}
	const state = []
	window.sessionStorage.setItem('user_info', "")
	localStorage.clear();
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.replace("/")
	}
}
function _executeApi (apiLink, credentials,getLoaderParams,getToken,commit, callback) {
	try{
		let response_array = [];
		if(credentials.localParams.module == 'ticket-reply'){ credentials.globalParams = credentials.globalParams.form }
		else if(credentials.localParams.type == 'form'){ credentials.globalParams = credentials.globalParams.form }
		getLoaderParams.pageLoader = true
		
		//let encryptedText = _encryptData(JSON.stringify(credentials.globalParams))
	// console.log(API)
		if(credentials.localParams.link){ 
			// API = credentials.localParams.link
			RxFactory.get(credentials.localParams.link, credentials.globalParams,getToken)
			.map(response => response.data)
			.subscribe(data => 
			{	getLoaderParams.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						response_array.res_data = data.data  //_decryptData(data.data)
						callback(false, response_array)
					}
					else{
						if('status' in data && data.status == 401){
	                        getLoaderParams.$root.$children[0].walletSessionTimeOut = true
	                    }else{
							response_array.res_data = data.msg
							callback(true, response_array)
						}
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}else{
			RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams,getToken)
			.map(response => response.data)
			.subscribe(data => 
			{	getLoaderParams.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						response_array.res_data = data.data  //_decryptData(data.data)
						callback(false, response_array)
					}
					else{
						if('status' in data && data.status == 401){
	                        getLoaderParams.$root.$children[0].walletSessionTimeOut = true
	                    }else{
							response_array.res_data = data.msg
							callback(true, response_array)
						}
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}
		
	}catch(ex){
			_handleErrorResponse(ex, commit)
	}
		
}
function _messageDisplayFunction(getParameter,getMessage,msgType){
	getParameter.$notify({
		group: 'foo',
		type : msgType,
		text: getMessage,
		duration: 10000,
		closeOnClick : true
	});
}

const ENC_KEY = "uzz0ffo4szq3vj2e37mq3wyesthhkp6y"     
const IV = ""
const CryptoJS = require('crypto-js');

function _encryptData(plainText){                    
    try{
        return CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Utf8.parse(ENC_KEY), {
           iv: CryptoJS.enc.Utf8.parse(IV), // parse the IV 
           padding: CryptoJS.pad.Pkcs7,
           mode: CryptoJS.mode.CBC
        }).toString() 
      
    }catch(ex){        
        return "INVALID DECRYPT REQUEST"
    }
}

function _decryptData(encryptText){
    try{
        let decrypted = CryptoJS.AES.decrypt(encryptText, CryptoJS.enc.Utf8.parse(ENC_KEY), {
           iv: CryptoJS.enc.Utf8.parse(IV), // parse the IV 
           padding: CryptoJS.pad.Pkcs7,
           mode: CryptoJS.mode.CBC
        }).toString(CryptoJS.enc.Utf8)    
        return JSON.parse(decrypted)
    }catch(ex){        
        return "INVALID ENCRYPT REQUEST"
    }            
}



function _ticketFunction(respData){
	// priority basis keys 
	//parent  ['1', '3', '4', '2']
	const getResponseData = respData
	let keyByPriortity = []
	let obj = {}
	let count = 0
	for(var key in  getResponseData){
		const parent_id = getResponseData[key].id
		keyByPriortity[getResponseData[key].priority] = parent_id
		obj["-1"] = keyByPriortity
		
		let childCount = 0
		count++
		const child = getResponseData[key].categories
		//console.log(child)
		if(child){
			let childPriority = []
			for(var i=0; i <= child.length-1; i++){
				const children = child[i]
				childPriority[children.priority] = children.id
				childCount++
				if(i ==  child.length-1){
					//empty
					var filtered = childPriority.filter(function (el) {
					  return el != null && el != '';
					});
					obj[parent_id] = filtered
				}
				if(i== child.length-1 && count == Object.keys(getResponseData).length){
					var childfiltered = keyByPriortity.filter(function (el) {
					  return el != null && el != '';
					});
					obj["-1"]= childfiltered
					return obj
				}
			}
		}else{
			if(count == Object.keys(getResponseData).length){
				var childfiltered = keyByPriortity.filter(function (el) {
				  return el != null && el != '';
				});
				obj["-1"]= childfiltered
				return obj;
			}
		}
		
	}
}




// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/actions.js